var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('monitoreo-dinamico',{attrs:{"number":_vm.number}}),_vm._v(" "),(this.$store.state.routeSheet.status=='false')?_c('v-btn',{staticClass:"no-print",attrs:{"color":"primary","dark":""},on:{"click":_vm.print}},[_vm._v("Imprimir")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1748abbb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/patient/proessat/CuestionarioProessat.vue
// module id = null
// module chunks = 